import React from "react";
import "../css/CallForPapers.css";
import formato from "../img/ingenieria/formato.docx";
import consentimiento from "../img/ingenieria/consentimiento.docx";
export default function CallForPapers() {
  return (
    <section className="cfp-container">
      <header className="cfp-header">
        <h4 className="cfp-label">📢 Call for Papers</h4>
        <h1 className="cfp-title">
          XLI Jornadas Sudamericanas de Ingeniería Estructural
        </h1>
        <p className="cfp-date">📅 9, 10 y 11 de noviembre de 2026</p>
        <center>
          <h3>Envia tu ponencia hasta el 31 de mayo de 2026</h3>
        </center>
      </header>
      <center>
        <a
          className="button"
          href="https://revistas.unilibre.edu.co/index.php/avances/index"
          target="_blank"
        >
          Enviar artículo
        </a>
      </center>

      <p className="cfp-description margin">
        Se invita a investigadores, docentes, profesionales y estudiantes de
        posgrado a presentar sus trabajos científicos y técnicos en las
        <strong> XLI Jornadas Sudamericanas de Ingeniería Estructural</strong>,
        espacio académico de alto nivel orientado al intercambio de
        conocimientos, avances tecnológicos y experiencias profesionales en el
        ámbito de la ingeniería estructural.
      </p>

      <section className="cfp-section">
        <h2 className="cfp-section-title">📄 Envío de trabajos</h2>

        <ul className="cfp-list">
          <li>
            <p>
              Los autores deberán enviar la ponencia completa en el
              <b> formato oficial de las Jornadas.</b>
              <a className="link-with-arrow" href={formato}>
                {" "}
                Descargar formato
              </a>
            </p>
          </li>

          <li>
            <p>
              El envío, revisión y publicación se hará mediante la revista{" "}
              Avances en Investigación Ingeniería mediante el Open Journal
              Systems (OJS).{" "}
              <a
                href="https://revistas.unilibre.edu.co/index.php/avances/index"
                target="_blank"
                rel="noopener noreferrer"
                className="link-with-arrow"
              >
                Avances Investigación en Ingeniería
              </a>{" "}
            </p>
          </li>

          <li className="cfp-deadline">
            <p>
              Fecha límite de envío: 🗓 <strong>31 de mayo de 2026</strong>
            </p>
          </li>
        </ul>
      </section>

      <section className="cfp-section">
        <h2 className="cfp-section-title">📝 Evaluación</h2>

        <ul className="cfp-list">
          <li>
            <p>Los trabajos serán sometidos a proceso de revisión académica.</p>
          </li>
          <li>
            <p>
              {" "}
              Notificación de veredicto:{" "}
              <strong>hasta el 31 de julio de 2026</strong>.
            </p>
          </li>
        </ul>
      </section>

      <section className="cfp-section">
        <h2 className="cfp-section-title">📌 Importante</h2>
        <p className="cfp-text">
          Cada pago de inscripción permite la publicación de hasta dos (2)
          artículos por autor.
        </p>
        <p className="cfp-text">
          Todos los artículos enviados serán sometidos a un proceso de revisión
          por pares académicos, con la evaluación de al menos dos revisores.
        </p>
        <p className="cfp-text">
          Los <strong>30 mejores artículos</strong> aprobados y cuyos autores
          hayan completado el pago de inscripción serán publicados en la revista
          <b> Avances Investigación en Ingeniería (ISSN: 1794-4953). </b> Esta
          revista se encuentra indexada en DOAJ, Dialnet, REDIB, Latindex, MIAR,
          EuroPub, Google Scholar, EZB, JournalTOCs, ScienceGate, CiteFactor y
          ResearchGate.
        </p>
        <p className="cfp-text">
          Recuerda que los artículos aceptados para participar en las jornadas
          deberán firmar el consentimiento de uso de datos e información. <a href={consentimiento} className="link-with-arrow"><b>Descargar consentimiento</b></a>
        </p>{" "}
       
        <h3 className="cfp-subtitle">De estos artículos seleccionados:</h3>
        <ul className="cfp-list">
          <li>
            <p>
              {" "}
              10 artículos serán publicados en un volumen especial en 2026.
            </p>
          </li>
          <li>
            <p>
              10 artículos serán publicados en otro volumen especial en 2027.
            </p>
          </li>
          <li>
            <p>
              {" "}
              10 artículos adicionales serán publicados en volúmenes regulares
              de la revista.
            </p>
          </li>
        </ul>
        <p className="cfp-text">
          Los demás trabajos aceptados serán publicados en las memorias del
          congreso con ISBN.
        </p>
      </section>

      <footer className="cfp-footer">
        <p className="fontsize16">
          Las XLI Jornadas constituyen un{" "}
          <b> foro técnico-científico de referencia en Sudamérica,</b>{" "}
          promoviendo el
          <b>
            {" "}
            desarrollo sostenible, la resiliencia estructural y la
            innovación{" "}
          </b>
          en el diseño y construcción de infraestructuras.
        </p>

        <p className="cfp-invitation fontsize16">
          Se invita cordialmente a la comunidad académica y profesional a
          <b> participar activamente en esta edición 2026.</b>
        </p>
      </footer>
    </section>
  );
}
